
import {ProfileFeedbackModel } from '../models/ProfileFeedbackModel.js';
import {ProfileFeedbackView } from '../views/ProfileFeedbackView.js';

export class ProfileFeedbackController {
    constructor() {

        this.model = new ProfileFeedbackModel();
        this.view = new ProfileFeedbackView();

        this.model.subscribe(state => this.view.render(state));
    }
}